import { useAuthContextUser } from "context/AuthContext";
import ExternalCertificationPackagesList from "./ExternalCertificationPackagesList";
import React, { useEffect, useState } from "react";
import { ButtonText, Col, Icon, Row, Typography } from "@visa/vds";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import MCSGridRevert from "components/MCSGridRevert";
import { ProductSelectionConst } from "pages/3DSStore/PurchaseProduct/Components/SelectProduct/ProductSelectionLogic";
import { AuthenticatedExternalUserRoutes } from "_constants/PageRoutes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { certificationPackageListService } from "services/certification.packageList";
import VstsAccessStatus from "pages/CertificationWorkflow/SharedComponents/VstsAccessStatus";
import NewCertificationPackageBtn from "pages/CertificationWorkflow/SharedComponents/NewCertificationPackageBtn";
import NewCertificationPackage from "pages/CertificationWorkflow/CertificationPackage/NewCertificationPackage";
import CertificationPackageWarningDialog from "pages/Dashboard/Components/ProductCertification/CertificationPackageWarningDialouge";
import { handleVstsButton } from "pages/CertificationWorkflow/SharedComponents/VstsAccessButton";

const ExternalCertificationPackagesPage = () => {
    const history = useHistory();
    const { promiseInProgress } = usePromiseTracker();
    const user = useAuthContextUser();
    const [error, setPageError] = useState(null);

    const [hasVstsAccess, setHasVstsAccess] = useState();
    const [vstsAccessStatusDescription, setVstsAccessStatusDescription] = useState("");
    const [vstsAccessStatusDescriptionNo, setVstsAccessStatusDescriptionNo] = useState(null)
    const [totalActivePackages, setTotalActivePackages] = useState(null);
    const [openNewCertificationPopup, setOpenNewCertificationPopup] = useState(false);
    const [openPackageWarningDialog, setOpenSubscriptionWarningDialog] = useState(false)


    const fetchData = () => {
        trackPromise(
            certificationPackageListService.GetPackageListBannerInfo()
                .then(result => {
                    setVstsAccessStatusDescription(result.data.vstsAccess.vstsAccessDescriptionText)
                    setHasVstsAccess(result.data.vstsAccess.vstsAccess)
                    setVstsAccessStatusDescriptionNo(result.data.vstsAccess.vstsAccessDescription)
                    setTotalActivePackages(result.data.totalCountActivePackage)
                }).catch(error => {
                    setPageError(error);
                })
        )
    }

    const handlePurchaseVstsSubscriptionBtnClick = () => {
        history.push({
            pathname: AuthenticatedExternalUserRoutes.STORE_PURCHASE,
            state: {
                selectedProduct: ProductSelectionConst.VSTS_CATEGORY
            }
        })
    }

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <GlobalAlertContext.Consumer>
            {(alertObj) => (
                <>
                    {promiseInProgress && <MCSOverlayLoading />}
                    <MCSGridRevert style={{ marginLeft: "20px" }}>
                        <Row>
                            <Typography style={{ marginLeft: "5px", color: "#1434CB" }} tag="h1" variant="headline">Certification Package List</Typography>
                        </Row>
                        <Row style={{ marginTop: "-20px" }}>
                            <Col>
                                <VstsAccessStatus vstsAccessDescriptionNo={vstsAccessStatusDescriptionNo} vstsAccess={hasVstsAccess} vstsAccessDescription={vstsAccessStatusDescription} />
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "-15px" }}>
                            <Col xs={3} md={4} lg={5} xl={4}>
                                <ButtonText
                                    id="purchases_VSTS_btn"
                                    disabled={!user.isSubscriptionManager}
                                    onClick={handlePurchaseVstsSubscriptionBtnClick}
                                    className="button-text"
                                    style={{ marginLeft: "-5px", backgroundColor: "white", border: "2px solid #0042B3", color: "#0042B3" }}>Purchase VSTS Subscription</ButtonText>
                            </Col>
                            <Col>
                            </Col>
                            <Col>
                                {hasVstsAccess &&
                                    <Col textAlign="right" className="certification-package-action-col">
                                        <ButtonText onClick={handleVstsButton} className="certification-package-btn" colorScheme="tertiary"><Icon name="maximize" resolution="low" />Go to Vsts</ButtonText>
                                    </Col>
                                }
                            </Col>
                            <Col>
                                <CertificationPackageWarningDialog openPackageWarningDialog={openPackageWarningDialog} setOpenPackageWarningDialog={setOpenSubscriptionWarningDialog} />
                                <NewCertificationPackageBtn totalCount={totalActivePackages} setOpenNewCertificationPopup={setOpenNewCertificationPopup} setOpenSubscriptionWarningDialog={setOpenSubscriptionWarningDialog} />
                                <NewCertificationPackage open={openNewCertificationPopup} setOpen={setOpenNewCertificationPopup} />
                            </Col>
                        </Row>
                        <Row>
                            <ExternalCertificationPackagesList
                                selectedBid={user.organization.bid}
                            />
                        </Row>
                    </MCSGridRevert>
                </>
            )
            }
        </GlobalAlertContext.Consumer>
    )
}

export default ExternalCertificationPackagesPage;